import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  itemContainer: theme => ({
    paddingHorizontal: 15,
    borderRadius: 20,
    height: 36,
    justifyContent: 'center',
    marginRight: 8,
    marginBottom: 10,
    backgroundColor: theme.colors.backgroundColorFour,
    borderWidth: 1,
    borderColor: theme.colors.dark_grey,
  }),
  selectedItemContainer: theme => ({
    backgroundColor: theme.colors.activeColor,
    borderWidth: 0,
  }),
  item: {
    fontSize: 16,
    textTransform: 'capitalize',
    marginTop: Platform.select({ ios: 4, android: 0 }),
  },
  selectedItem: theme => ({
    color: theme.colors.activeColorTwo,
  }),
});
